var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankUpMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C7.448 19 7 19.448 7 20C7 20.552 7.448 21 8 21H16C16.552 21 17 20.552 17 20C17 19.448 16.552 19 16 19H8Z",
    fill: "#404D6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9873 3C11.7313 3 11.4953 3.08601 11.2993 3.28101C10.2993 4.28101 4.30026 10.281 3.29926 11.281C2.67025 11.911 3.09624 13 3.98724 13H6.98725V16C6.98725 16.552 7.43525 17 7.98725 17H15.9873C16.5393 17 16.9873 16.552 16.9873 16V13H19.9873C20.8783 13 21.3363 11.911 20.7063 11.281L12.7062 3.28101C12.5102 3.08601 12.2433 3 11.9873 3Z",
    fill: "#6B758B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankUpMenu);
export default __webpack_public_path__ + "static/media/Rank-up-menu.b9685c1c25d9443310de5c360a34456d.svg";
export { ForwardRef as ReactComponent };